<template>
    <div style="position: relative;z-index:9;">
        <div class="searchCtn">
            <img src="../../../assets/dataPack/AnnualPurchase/搜索.png" alt="" class="searchImg">
            <input type="text" v-model="keyword" class="searchInput1" placeholder="输入区域名称或经纬度查询">
            <div v-if="keyword!=''" class="clearBtn" @click="clear()"></div>
        </div>

        <v-card tile class="elevation-1" v-if="resultShow &&items.length > 0 && keyword !=''" style="background-color: rgb(255,255,255)">
            <template v-for="(item,index) in items" >
                <v-hover v-if="index <= 10" :key="index">
                    <v-card
                            :dark="false"
                            @click="select(item)"
                            slot-scope="{ hover }"
                            :class="hover ? 'gradientbuttonhover' : 'gradientbuttonhoveroff'"
                            height="39px"
                            tile
                    >
                        <v-layout
                                class="ma-0"
                                row
                                align-center
                                justify-start
                                fill-height
                        >
                            <v-icon :color="item.detail === $vuetify.lang.t('$vuetify.searchBar.targetLibrary') ? 'primary': ''" class="ma-2">{{item.detail === $vuetify.lang.t('$vuetify.searchBar.targetLibrary') ? 'place' : 'search'}}</v-icon>
                            <div class="subheading " style="max-width:200px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap; " :title="item.name">{{item.name}}</div>
                            <div class="body-2 ml-3" style="max-width:94px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap; color:rgb(150,150,150)" :title="item.detail">{{item.detail}}</div>
                        </v-layout>
                    </v-card>
                </v-hover>
            </template>
        </v-card>
        <v-card tile class="elevation-1" v-if="resultShow && items.length == 0 && keyword !=''" style="background-color: rgb(255,255,255)">
            <v-card
                    :dark="false"
                    height="39px"
                    tile
            >
                <v-layout
                        class="ma-0"
                        row
                        align-center
                        justify-center
                        fill-height
                >
                    <svg t="1585644618793" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1639" width="24" height="24"><path d="M945.643909 899.025661 767.204891 720.555943c-1.134847-1.136893-2.585895-1.641383-3.815909-2.555196 58.732659-68.858274 94.376461-158.0302 94.376461-255.623935 0-217.74114-176.577624-394.350486-394.350486-394.350486-217.771839 0-394.350486 176.608324-394.350486 394.350486 0 34.792411 4.952802 68.322062 13.406335 100.464109 10.219759-15.58393 36.712133-52.364625 52.549843-59.237149-1.702782-13.532201-2.838651-27.220968-2.838651-41.22696 0-182.917006 148.31493-331.264683 331.264683-331.264683s331.263659 148.346653 331.263659 331.264683c0 143.771451-91.758844 265.811971-219.7284 311.643809-6.088672 25.960255-15.929808 50.720172-29.335119 73.747631 65.640999-14.005992 125.32124-44.097334 174.432775-86.301552 0.914836 1.199315 1.419326 2.648316 2.524496 3.784186l178.468694 178.375573c12.33391 12.396331 32.268938 12.396331 44.601824 0C958.007495 931.355997 958.007495 911.358547 945.643909 899.025661L945.643909 899.025661zM480.417189 541.360701c-45.421492-45.421492-105.827257-70.436212-170.111353-70.436212-64.284095 0-124.657114 25.01472-170.07963 70.436212-45.453215 45.422516-70.466911 105.826234-70.466911 170.109306 0 64.285119 25.013697 124.658138 70.466911 170.111353 45.453215 45.454238 105.857956 70.465888 170.111353 70.465888 0 0 0 0 0.030699 0 64.253396 0 124.659161-25.045419 170.07963-70.465888 45.422516-45.388746 70.437236-105.826234 70.437236-170.111353C550.853401 647.217634 525.837658 586.812893 480.417189 541.360701zM435.815365 836.979536c-33.530674 33.531698-78.100776 51.982932-125.477806 51.982932l0 0c-47.408753 0-92.010577-18.48398-125.509529-51.982932-33.529651-33.529651-51.982932-78.099752-51.982932-125.509529 0-47.408753 18.453281-91.977831 51.982932-125.506459 33.529651-33.532721 78.069053-51.953256 125.477806-51.953256 47.409776 0 91.978854 18.453281 125.509529 51.953256 33.529651 33.529651 51.981908 78.097706 51.981908 125.506459C487.797273 758.911506 469.345016 803.450908 435.815365 836.979536zM420.895561 600.914052c-12.33391-12.335956-32.268938-12.335956-44.601824 0l-65.988924 65.986877-65.9879-65.986877c-12.332886-12.335956-32.267914-12.335956-44.600801 0-12.33391 12.332886-12.33391 32.266891 0 44.601824l65.986877 65.985854-65.986877 65.9879c-12.33391 12.332886-12.33391 32.267914 0 44.601824 6.15007 6.151094 14.226003 9.242502 22.299889 9.242502 8.075933 0 16.150842-3.091408 22.300912-9.242502l65.9879-65.986877 65.988924 65.986877c6.15007 6.151094 14.224979 9.242502 22.299889 9.242502 8.075933 0 16.150842-3.091408 22.300912-9.242502 12.33391-12.33391 12.33391-32.268938 0-44.601824l-65.986877-65.9879 65.986877-65.985854C433.196725 633.212666 433.196725 613.246939 420.895561 600.914052L420.895561 600.914052z" p-id="1640" fill="#8a8a8a"></path></svg>
                    <div class="body-2 ml-3" style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap; color:rgb(150,150,150);margin-top: 2px">
                        {{$vuetify.lang.t('$vuetify.searchBar.noResults')}}
                    </div>
                </v-layout>
            </v-card>
        </v-card>
    </div>
</template>

<script>
// import L from 'leaflet'
import coordtransform from 'coordtransform'
import { fromLonLat,toLonLat,transform } from 'ol/proj'
export default {
name: "searchInput",
data() {
    return {
        keyword:'',
        savedKeyword: '',
        resultShow: true,
        selected: false,
        poiResult: [],
        latLng: [],
        // tmp:null,
    };
},
computed: {
    items() {
        var tmp = []
        tmp = tmp.concat(this.latLng)
        tmp.push(...this.poiResult)
        return tmp
    }
},
methods: {
    getKey() {
        return localStorage.getItem("token");
    },
    clear(){
        this.keyword = ''
        this.savedKeyword = ''
        this.poiResult = []
        this.latLng = []
        this.resultShow = false
        // this.clearTmp()
        this.$parent.$refs.mainmap.location.clear();
    },
    select(item){
        this.selected = true
        // this.point = null
        // this.clearTmp()
        let p3857=[]
        if(item.location.lng !== ''){
            this.savedKeyword = item.name
            this.keyword = item.name
            let p;//4326坐标点
            if(/高德地图/.test(item.detail)) {
                p = coordtransform.gcj02towgs84(item.location.lng, item.location.lat);
            }else if(/百度地图/.test(item.detail)){
                //百度经纬度坐标转国测局坐标
                let bd09togcj02Result = coordtransform.bd09togcj02(item.location.lng, item.location.lat);
                //国测局坐标转wgs84坐标
                p = coordtransform.gcj02towgs84(bd09togcj02Result[0], bd09togcj02Result[1]);
            }else {//由于接口调用的百度，所以按地名查出来的点都是百度坐标系的，已经转换成wgs84坐标系了
                //这里location已经是wgs84坐标系的点了
                p=[item.location.lng, item.location.lat]
            }
            // this.point = {
            //     type: "Point",
            //     coordinates:p
            // }
            p3857=fromLonLat(p);
            this.$parent.$refs.mainmap.setSquareAreaByCoordinates(25,p)
        }
        // this.$parent.$refs.mainmap.jumpTo(p3857)


        // if(this.point){
            // this.tmp = L.GeoJSON.geometryToLayer(this.point)
            // this.$parent.$parent.$parent.$refs.map.mapObject.addLayer(this.tmp)
            // this.$parent.$parent.$parent.$refs.map.mapObject.setView([this.point.coordinates[1], this.point.coordinates[0]],14)
            // this.$parent.$parent.$parent.drawQuick(this.point.coordinates)
        // }

        this.poiResult = []
        this.latLng = []
        this.resultShow = false
    },
    search() {
        if (this.keyword != '' && !this.selected) {
        // this.clearTmp()
        this.axios.get("/koa_back/searchPOI?keyword=" + this.keyword)
            .then((res) => {
                this.poiResult = []
                res.data.data.forEach( (item) => {
                    if(item.location){
                        let tmp = {
                            name: '',
                            detail: '',
                            location: ''
                        }
                        tmp.name = item.title
                        tmp.detail = item.city + item.district
                        //国测局坐标转wgs84坐标
                        let location = coordtransform.gcj02towgs84(item.location.lng, item.location.lat);
                        tmp.location = {lng:location[0],lat:location[1]}
                        this.poiResult.push(tmp)
                    }
                })
            })
        }
        this.selected = false
    },
    // clearTmp(){
    //     if(this.tmp)
    //     this.$parent.$parent.$parent.$refs.map.mapObject.removeLayer(this.tmp)
    // }
},
watch: {
    keyword() {
        if(this.keyword == null){this.keyword = ''}
        if(this.keyword != this.savedKeyword){
            this.resultShow = true
        }
        this.keyword = this.keyword.replace(/，/g, ',')
        this.keyword = this.keyword.replace(/\s/g,'')
        var t1 = /^-?[0-9]*\.?[0-9]*,|，.-?[0-9]*\.?[0-9]*$/
        this.latLng = []
        if(this.keyword.match(t1)!== null){
            let tmp = this.keyword.split(',')
            let lat = parseFloat(tmp[0])
            let lng = parseFloat(tmp[1])
            if(tmp.length === 2 && !isNaN(lat) && !isNaN(lng)){
                if(lat>=-90 && lat<=90 && lng>=-180 && lng<=180) {
                    this.latLng.push({
                        name:lat + ',' + lng,
                        detail: 'WGS84坐标系(纬度,经度)',
                        location: {lat: lat, lng: lng}
                    })
                    this.latLng.push({
                        name:lat + ',' + lng,
                        detail: '百度地图(纬度,经度)',
                        location: {lat: lat, lng: lng}
                    })
                    this.latLng.push({
                        name:lat + ',' + lng,
                        detail: '高德地图/谷歌地图(纬度,经度)',
                        location: {lat: lat, lng: lng}
                    })
                }
                if(lat>=-180 && lat<=180 && lng>=-90 && lng<=90 && lat!=lng) {
                    this.latLng.push({
                        name: lat + ',' + lng,
                        detail: 'WGS84坐标系(经度,纬度)',
                        location: {lat: lng, lng: lat}
                    })
                    this.latLng.push({
                        name: lat + ',' + lng,
                        detail: '百度地图(经度,纬度)',
                        location: {lat: lng, lng: lat}
                    })
                    this.latLng.push({
                        name: lat + ',' + lng,
                        detail: '高德地图/谷歌地图(经度,纬度)',
                        location: {lat: lng, lng: lat}
                    })
                }
            }
        }

        if (this.keyword === null){this.keyword = ''}
        if (this.keyword === ''){
            this.poiResult = []
        }
        this.search()
    }
},
mounted(){
  
}
}
</script>

<style scoped>
.searchCtn{
    position: relative;
    margin-top: 7px;
    margin-left: 4px;
    /* width: 345px; */
    /* height: 34px; */
    /* border-radius: 2px; */
    /* border: 1px solid #E9EBEE; */
}
.searchImg{
    position: absolute;
    width: 17px;
    top: 9px;
    left: 10px;
}
.searchInput1{
    position: absolute;
    top: 8px;
    left: 39px;
    width: 400px;
    height: 17px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #000;
    line-height: 17px;
    text-align: left;
    border: none;
    outline: none;
}
.clearBtn{
    position: absolute;
    width: 15px;
    height: 15px;
    top: 9px;
    right: 10px;
    background: url("../../../assets/dataPack/AnnualPurchase/关闭.png");
    background-size: cover;
    cursor: pointer;
}
.elevation-1{
    position: absolute;
    margin-top: 37px;
    width: 456px;
    /* border-radius: 2px;
    border: 1px solid #E9EBEE; */
}
</style>